"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _PieChart = require("@mui/x-charts/PieChart");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : equipmentList.js
* Description : Ce fichier contient la définition de la page equipmentList 
*               Cette page liste les produits clients
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* EquipmentList : affiche la page qui liste les produits client
*                 filtrage de la liste possible selon le produit et la société
*                 un lien permet d'afficher une page avec un formulaire pour créer un nouveau produit client
*                 un click sur le produit client permet d'afficher sa page avec ses informations détaillées
*                 un lien permet d'accéder à la gestions des sous-ensembles des produits client
*
* Type : page 
*
* Parametres : 
*  None
*/
function EquipmentList() {
  // Define useState hooks

  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    equipments = _useState2[0],
    setEquipments = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    statusEquipments = _useState4[0],
    setStatusEquipments = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setDataLoading = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    products = _useState8[0],
    setProducts = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedProduct = _useState0[0],
    setSelectedProduct = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    filteredEquipments = _useState10[0],
    setFilteredEquipments = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    filteredCompanyEquipments = _useState12[0],
    setFilteredCompanyEquipments = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    graphWidth = _useState14[0],
    setGraphWidth = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    graphHeight = _useState16[0],
    setGraphHeight = _useState16[1];
  var _useState17 = (0, _react.useState)({
      left: 0
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    graphMargin = _useState18[0],
    setGraphMargin = _useState18[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    setSelectedCompany = _useApi.setSelectedCompany,
    selectedCompany = _useApi.selectedCompany,
    applicationName = _useApi.applicationName,
    setPreviousUrl = _useApi.setPreviousUrl;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function updateFilteredEquipments() {
    // Filtering product
    if (selectedProduct > 0) {
      setFilteredEquipments(filteredCompanyEquipments.filter(function (equipment) {
        return equipment.product["id"] === Number(selectedProduct);
      }));
    } else {
      setFilteredEquipments(filteredCompanyEquipments);
    }
  }
  function updateFilteredCompanyEquipments() {
    // Filtering company
    setSelectedProduct(0);
    if (selectedCompany > 0) {
      setFilteredCompanyEquipments(equipments.filter(function (equipment) {
        return equipment.company["id"] === Number(selectedCompany);
      }));
    } else {
      setFilteredCompanyEquipments(equipments);
    }
  }
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, _yield$Promise$all, _yield$Promise$all2, resProduct, resEquipment, _yield$Promise$all3, _yield$Promise$all4, dataProduct, dataEquipment, product_list, equipment_list;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Requests in parallel to win time 
            _context.n = 1;
            return Promise.all([
            // Products
            fetch(path + "/api/eq-prct/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            }),
            // Equipments
            fetch(path + "/api/eq-eqnt/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            })]);
          case 1:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            resProduct = _yield$Promise$all2[0];
            resEquipment = _yield$Promise$all2[1];
            _context.n = 2;
            return Promise.all([resProduct.json(), resEquipment.json()]);
          case 2:
            _yield$Promise$all3 = _context.v;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            dataProduct = _yield$Promise$all4[0];
            dataEquipment = _yield$Promise$all4[1];
            // Set variables
            product_list = dataProduct["results"];
            setProducts(product_list);
            setStatusEquipments(resEquipment["status"]);
            equipment_list = dataEquipment["results"];
            setEquipments(equipment_list);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  function graphEquipmentRepartition() {
    var nbBoxitunnel = 0;
    var nbBoxilab = 0;
    var nbBoxistick = 0;
    var nbBoxirover = 0;
    filteredCompanyEquipments.forEach(function (equipment) {
      if (equipment.product['name'] === 'Boxitunnel') {
        nbBoxitunnel = nbBoxitunnel + 1;
      } else if (equipment.product['name'] === 'BoxiLab') {
        nbBoxilab = nbBoxilab + 1;
      } else if (equipment.product['name'] === 'Boxistick') {
        nbBoxistick = nbBoxistick + 1;
      } else {
        nbBoxirover = nbBoxirover + 1;
      }
    });
    var data_graph = [{
      id: 0,
      value: nbBoxitunnel,
      label: 'Boxitunnel'
    }, {
      id: 1,
      value: nbBoxilab,
      label: 'Boxilab'
    }, {
      id: 2,
      value: nbBoxistick,
      label: 'Boxistick'
    }, {
      id: 3,
      value: nbBoxirover,
      label: 'Boxirover'
    }];
    return data_graph;
  }
  function updateGraphSize() {
    if (screenWidth > 1000) {
      setGraphWidth(400);
      setGraphHeight(200);
      setGraphMargin({
        left: -100,
        right: 50
      });
    } else if (screenWidth > 650) {
      setGraphWidth(380);
      setGraphHeight(150);
      setGraphMargin({
        left: -100,
        right: 50
      });
    } else {
      setGraphWidth(320);
      setGraphHeight(130);
      setGraphMargin({
        left: -120,
        right: 80
      });
    }
  }
  var filterReset = function filterReset(event) {
    event.preventDefault();
    setFilteredEquipments(equipments);
    setSelectedProduct(0);
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      updateGraphSize();
      setDataLoading(true);
      if (applicationName === "BOXILUMIX") {
        setSelectedCompany(currentUser['company']['id']);
      }
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    updateFilteredCompanyEquipments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipments, selectedCompany]);
  (0, _react.useEffect)(function () {
    updateFilteredEquipments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredCompanyEquipments, selectedProduct]);
  (0, _react.useEffect)(function () {
    updateGraphSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Chargement des donn\xE9es"
        }) : statusEquipments === 200 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "margin-bottom",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PieChart.PieChart, {
              series: [{
                arcLabel: function arcLabel(item) {
                  return "".concat(item.value);
                },
                arcLabelMinAngle: 1,
                data: graphEquipmentRepartition(),
                labelPosition: 'outside',
                labelLineLength: 10 // Longueur de la ligne reliant le label au segment
                //labelLineOffset: 5,    // Décalage de la ligne par rapport au segment
              }],
              sx: _defineProperty({}, "& .".concat(_PieChart.pieArcLabelClasses.root), {
                fontWeight: 'bold',
                fill: 'white'
              }),
              width: graphWidth,
              height: graphHeight,
              margin: graphMargin
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: screenWidth > 650 ? 'grid-1-3' : null,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "flex-rows",
                children: [applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.GotoPage, {
                    onClick: setPreviousUrl('/equipments'),
                    path: "/equipments/subset",
                    children: "G\xE9rer les sous-ensembles"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.GotoPage, {
                    path: "/documents",
                    children: "G\xE9rer la documentation"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.AddItem, {
                    path: "/equipments/new",
                    children: "Ajouter un produit client"
                  })]
                }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  children: "Filtres"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                  labelText: "Produit",
                  choices: products.sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  }),
                  choiceParam: 'name',
                  selectedItem: selectedProduct,
                  setSelectedItem: setSelectedProduct,
                  subfilter: false
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: filterReset,
                    className: "button-secondary clickable",
                    children: "Sans filtres"
                  })
                })]
              }), screenWidth > 650 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "scroll-list-c",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
                  className: "subtitle",
                  children: ["Nombre de produits client : ", filteredEquipments.length]
                }), filteredEquipments && filteredEquipments.length !== 0 ? filteredEquipments.sort(function (a, b) {
                  return a.serial_number > b.serial_number ? 1 : -1;
                }).map(function (equipment) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ItemLink, {
                    id: equipment['id'],
                    path: "/equipments/",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        children: applicationName === 'BOXIBRAIN' || currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                          className: "flex-row justify-between",
                          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
                            className: "item-text",
                            children: [equipment['product']['name'], " ", equipment['serial_number'], " - ", equipment['company']['name']]
                          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                            className: "item-text item-text-right",
                            children: equipment['identifier']
                          })]
                        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                          className: "flex-row justify-between",
                          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
                            className: "item-text",
                            children: [equipment['product']['name'], " ", equipment['serial_number']]
                          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                            className: "item-text item-text-right",
                            children: equipment['identifier']
                          })]
                        })
                      })
                    })
                  }, equipment['id']);
                }) : applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: "Aucun produit client actuellement. Veuillez en cr\xE9er un !"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: "Aucun produit client actuellement."
                })]
              })]
            })
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          children: "Connexion failed"
        })
      })
    })]
  });
}
var _default = exports["default"] = EquipmentList;